import { AlertCircle, AlertTriangle, CheckCircle2, Info, X } from 'lucide-react';
import './Notice.css';

/**
 * Ekran uyarısı — tek kalıp.
 *
 * Panelde her sayfa kendi uyarı kutusunu kuruyordu: kimi yalnız kırmızı şerit, kimi düz metin,
 * kimi sadece toast. Sonuç: aynı ciddiyetteki iki mesaj iki farklı ağırlıkta görünüyor ve
 * kullanıcı hangisinin iş durduran olduğunu ayırt edemiyordu.
 *
 * Kural: kalıcı bilgi/uyarı SAYFADA durur (Notice), anlık işlem sonucu TOAST'ta geçer.
 * Yıkıcı onay hiçbir zaman native confirm() ile sorulmaz.
 */
const TONES = {
    info: { icon: Info, cls: 'notice-info' },
    warn: { icon: AlertTriangle, cls: 'notice-warn' },
    error: { icon: AlertCircle, cls: 'notice-error' },
    success: { icon: CheckCircle2, cls: 'notice-success' },
};

const Notice = ({ tone = 'info', title, children, action, onDismiss, compact = false }) => {
    const { icon: Icon, cls } = TONES[tone] || TONES.info;

    return (
        <div className={`notice ${cls} ${compact ? 'notice-compact' : ''}`} role={tone === 'error' ? 'alert' : 'status'}>
            <Icon size={compact ? 15 : 17} className="notice-icon" aria-hidden="true" />
            <div className="notice-body">
                {title && <div className="notice-title">{title}</div>}
                {children && <div className="notice-text">{children}</div>}
            </div>
            {action && <div className="notice-action">{action}</div>}
            {onDismiss && (
                <button type="button" className="notice-dismiss" onClick={onDismiss} aria-label="Uyarıyı kapat">
                    <X size={14} />
                </button>
            )}
        </div>
    );
};

export default Notice;
